export default "__VITE_ASSET__BEoJa5H___"